// Shared Supabase connection details + helpers used by the cloud features
// (backup/restore and licensing). We talk to Supabase over its PostgREST HTTP
// API with plain `fetch` rather than the @supabase/supabase-js SDK, to avoid
// adding an npm dependency.

export const SUPABASE_URL = 'https://arhiyyjbezbxqwnzgtth.supabase.co';
export const SUPABASE_KEY = 'sb_publishable_8dgTidwRoQP3qvbV4A4Kjw_ZOycbynu';

export const REST = `${SUPABASE_URL}/rest/v1`;

export function sbHeaders(extra?: Record<string, string>): Record<string, string> {
  return {
    apikey: SUPABASE_KEY,
    Authorization: `Bearer ${SUPABASE_KEY}`,
    'Content-Type': 'application/json',
    ...extra,
  };
}

// Extract a useful error message from a failed PostgREST response.
export async function sbError(res: Response): Promise<Error> {
  let detail = '';
  try {
    const body = await res.json();
    detail = body.message || body.hint || JSON.stringify(body);
  } catch {
    detail = await res.text().catch(() => '');
  }
  return new Error(`Cloud error ${res.status}: ${detail || res.statusText}`);
}
